export default [
    {
        name:"InventProtect",
        path:"InventProtect",
        component:()=>import("@/view/WebViews/RightsProtection/InventProtect"),
        meta:{
            title:"发明专利维权",
        }
    },
    {
        name:"UtilityModelProtect",
        path:"UtilityModelProtect",
        component:()=>import("@/view/WebViews/RightsProtection/UtilityModelProtect"),
        meta:{
            title:"实用新型专利维权",
        }
    },
    {
        name:"DesignPatentProtect",
        path:"DesignPatentProtect",
        component:()=>import("@/view/WebViews/RightsProtection/DesignPatentProtect"),
        meta:{
            title:"外观设计专利维权",
        }
    },
    {
        name:"GoodsMarksProtect",
        path:"GoodsMarksProtect",
        component:()=>import("@/view/WebViews/RightsProtection/GoodsMarksProtect"),
        meta:{
            title:"商品商标维权",
        }
    },
    {
        name:"ServiceMarkProtect",
        path:"ServiceMarkProtect",
        component:()=>import("@/view/WebViews/RightsProtection/ServiceMarkProtect"),
        meta:{
            title:"服务商标维权",
        }
    },
    {
        name:"CopyrightProtect",
        path:"CopyrightProtect",
        component:()=>import("@/view/WebViews/RightsProtection/CopyrightProtect"),
        meta:{
            title:"著作权维权",
        }
    }

]